import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link } from 'components/ui';
import BasicSkuItem from 'components/RwdBasket/Carts/CartLayout/SkuItem/BasicSkuItem';
import InfoButton from 'components/InfoButton/InfoButton';
import RwdBasketActions from 'actions/RwdBasketActions/RwdBasketActions';
import { globalModals, renderModal } from 'utils/globalModals';
import FrictionlessUtils from 'utils/FrictionlessCheckout';

import localeUtils from 'utils/LanguageLocale';
import CartLayoutEN from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_en_US';
import CartLayoutFR from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_fr_CA';

const { openShippingRestrictionsInfoModal } = RwdBasketActions;
const { SHIPPING_METHOD_RESTRICTIONS } = globalModals;
const getText = localeUtils.getLocalisedDataFromResource(CartLayoutEN, CartLayoutFR);

function ShippingRestrictions(globalModalsData) {
    const title = getText('shippingRestrictions');
    const isFCReleaseThreeEnabled = FrictionlessUtils.isFCReleaseThreeEnabled();

    return (
        <Link
            onClick={() => {
                isFCReleaseThreeEnabled
                    ? renderModal(globalModalsData[SHIPPING_METHOD_RESTRICTIONS])
                    : openShippingRestrictionsInfoModal({
                        title,
                        message: getText('shippingRestrictionModalText'),
                        buttonText: getText('gotIt')
                    });
            }}
            data-at={Sephora.debug.dataAt('shipping_restrictions_btn')}
            color='gray'
            fontSize={['sm', 'base']}
            marginTop={3}
        >
            {title}
            <InfoButton
                marginLeft={-1}
                size={13}
            />
        </Link>
    );
}

function ShippingDeliveryBasicSkuItem({
    item,
    changeMethodLabel,
    callbacks,
    belowPriceContent = [],
    itemDeliveryMethod,
    preferredStoreInfo,
    preferredZipCode,
    userId,
    hasMetFreeShippingThreshhold,
    isSignedInBIUser,
    isOutOfStock,
    globalModals: globalModalsData
}) {
    if (item.sku.isHazmat) {
        belowPriceContent.push(() => ShippingRestrictions(globalModalsData));
    }

    return (
        <BasicSkuItem
            item={item}
            changeMethodLabel={changeMethodLabel}
            callbacks={callbacks}
            belowPriceContent={belowPriceContent}
            itemDeliveryMethod={itemDeliveryMethod}
            preferredStoreInfo={preferredStoreInfo}
            preferredZipCode={preferredZipCode}
            userId={userId}
            hasMetFreeShippingThreshhold={hasMetFreeShippingThreshhold}
            isSignedInBIUser={isSignedInBIUser}
            isOutOfStock={isOutOfStock}
        />
    );
}

export default wrapFunctionalComponent(ShippingDeliveryBasicSkuItem, 'ShippingDeliveryBasicSkuItem');
